import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["emphasis", "children", "textAlign", "verticalAlign"];
import React from 'react';
import { Grid } from 'semantic-ui-react';
import { ChildrenPropType, TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';
import { getTextAlignClass, getVerticalAlignClass } from './utils';

function CTA(_ref) {
  var emphasis = _ref.emphasis,
      children = _ref.children,
      textAlign = _ref.textAlign,
      verticalAlign = _ref.verticalAlign,
      extraProps = _objectWithoutProperties(_ref, _excluded);

  var extraClasses = [emphasis ? 'emphasis' : '', getTextAlignClass(textAlign), getVerticalAlignClass(verticalAlign)].join(' ');
  return /*#__PURE__*/React.createElement(Grid.Column, _extends({
    className: "cta-banner-item ".concat(extraClasses)
  }, extraProps), children);
}

CTA.defaultProps = {
  children: null,
  emphasis: false,
  textAlign: undefined,
  verticalAlign: undefined
};
export default CTA;